import { Box, Typography, TextField, Button, CircularProgress, Alert, AlertTitle } from '@mui/material';
import type { LoginRequestPayload } from '@weft/api-definition';
import { VyIcon } from '@weft/icons';
import { isNotNullOrUndefined } from '@weft/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { ContractUsDialog } from './contact-us-dialog/ContactUsDialog';
import { PasswordInput } from './PasswordInput';

export const LoginPageForm: React.FC = () => {
  const { register, formState: { errors, isSubmitting, isSubmitSuccessful, isSubmitted } } = useFormContext<LoginRequestPayload>();

  const usernameRegister = register('username');
  const passwordRegister = register('password');

  return (
    <div className="w-[456px] p-8 flex flex-col gap-8">
      <VyIcon
        icon="Logo"
        className="text-transparent"
      />
      <Box>
        <Typography
          variant="h5"
          fontWeight={300}
        >
          Welcome Back!
        </Typography>
        <Typography
          variant="body2"
          fontWeight={300}
          color="#1B3D5599"
          fontSize={14}
        >
          Please sign in to continue
        </Typography>
      </Box>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}
      >
        <TextField
          label="Email Address"
          variant="filled"
          size="medium"
          fullWidth
          error={isNotNullOrUndefined(errors.username)}
          helperText={errors.username?.message}
          {...usernameRegister}
        />

        <PasswordInput
          error={isNotNullOrUndefined(errors.password)}
          helperText={errors.password?.message}
          {...passwordRegister}
        />

        <Link
          to="/password/reset"
          style={{
            color: '#1A5BC8',
            fontSize: 12,
            fontWeight: 300,
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          Forgot Password?
        </Link>
      </Box>

      <Button
        variant="contained"
        fullWidth
        type="submit"
        size="large"
        endIcon={!isSubmitting && <VyIcon icon="ArrowSmallRight" />}
      >
        {isSubmitting && !isSubmitSuccessful ?
          <CircularProgress
            size={24}
            color="inherit"
          /> : 'Log In'}
      </Button>

      {isSubmitted && !isSubmitSuccessful && (
        <Alert severity="error">
          <AlertTitle>Log in failed!</AlertTitle>
          Please ensure username and password are valid.
        </Alert>
      )}

      <Box sx={{
        display: 'flex',
        gap: '8px',
        justifyContent: 'center',
        padding: '16px',
        backgroundColor: '#0D1B270A',
        borderRadius: '8px',
      }}
      >
        <Typography
          variant="body1"
          fontWeight={300}
          color="#1B3D5599"
          fontSize={16}
        >
          Don’t have an account?
        </Typography>

        <ContractUsDialog>
          <Link
            to="/contact"
            style={{
              display: 'inline',
              color: '#1A5BC8',
              fontWeight: 300,
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Contact us
          </Link>
        </ContractUsDialog>
      </Box>
    </div>
  );
};